import { BooleanCellPrintReadable } from "@/react/features/globalization/cellRenderers";
import { booleanEdit } from "@/react/features/globalization/components/cell-edit-renders/booleanEdit";
import {
  MemoHorizontalTable,
  HorizontalTableContext,
} from "@/react/features/globalization/HorizontalTable";
import React, { useContext } from "react";
import { canEditColumn } from "@/react/features/globalization/rights";
import { tooltips } from "@/react/features/globalization/tooltips";

const hardPhonesColumns = [
  {
    name: "Distribution",
    tooltip: tooltips.Distribution,
    field: (row) => <BooleanCellPrintReadable value={row.distribution} />,
    edit: (row, onChange) => booleanEdit(row, "distribution", onChange),
    id: "distribution",
    meta: { right: "distribution" },
  },
  {
    name: "PSU",
    tooltip: tooltips.PSU,
    field: (row) => <BooleanCellPrintReadable value={row.PSU} />,
    edit: (row, onChange) => booleanEdit(row, "PSU", onChange),
    id: "PSU",
    meta: { right: "PSU" },
  },
];
export const HardPhones = ({ row, onChange }) => {
  const data = useContext(HorizontalTableContext);

  return (
    <MemoHorizontalTable
      data={[row]}
      onCellChange={onChange}
      columns={hardPhonesColumns}
      meta={data.meta}
      isEdit={data.isEdit}
      canEdit={(meta, column) =>
        canEditColumn(meta.rights || [], "international_fields", column)
      }
    />
  );
};
